<template>
    <div :class="`flex flex-row flex-shrink-0  items-justified-space-between my-2 ` + blockSize">
        <div :class="`flex flex-col `+ rowSize">
            <h4 class="text-sm font-bold py-2 ">{{ description.header }}</h4>
            <div class="text-sm" v-html="description.text"></div>
        </div>
        <div v-if="description.images.length === 1" class="flex flex-col justify-items-center justify-center">
            <img v-for="image in description.images" :src="image.sizes.thumbnail" :alt="description.header">
        </div>
        <div v-if="description.images.length > 1" class="flex flex-col justify-items-center justify-center ">
            <div class="grid grid-rows-1 grid-flow-col gap-4">
                <div class="w-32" v-for="image in description.images" >
                    <img class="image h-32" :src="image.sizes.large" :alt="description.alt"/>
                    <p class="text-xs text-center pt-2">{{image.alt}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'DescriptionView',
    props: {
        description: {},
        descriptionsTotal: {}
    },
    computed: {
        blockSize(){
            if( this.descriptionsTotal === 1) {
                return 'w-full'
            }

            if( this.descriptionsTotal === 2) {
                return 'pr-4 w-full md:w-1/2'
            }

            return 'mr-4 w-full md:w-auto';
        },
        rowSize() {
            if( this.descriptionsTotal === 1) {
                return 'w-full'
            }
            // if( this.descriptionsTotal === 2) {
            //     return 'w-full md:w-1/2'
            // }
            return 'w-full md:w-96'
        }
    }
}
</script>